import React from 'react';
import CardItem from './CardItem';
import './Cards.css';

function Cards({ cardsData = [] }) {
  return (
    <div className='cards'>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            {cardsData.map((card, index) => (
              <CardItem
                key={index}
                src={card.src}
                // text={card.text}
                label={card.label}
                path={card.path}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
